<script lang="ts" setup>
useAppProvides()
</script>

<template>
  <CommonApp />
</template>
